export const filterCustomByDuration = (searchResults, maxDurationParam) => {
  let newCluster = searchResults
    .map(clusterObj => {
      let newOptions = clusterObj.combinations
        .map(singleLeg => {
          if (singleLeg.next_leg_options) {
            const filteredFlights = singleLeg.next_leg_options?.filter(
              nextOptions => nextOptions.option.flight_time <= maxDurationParam
            );

            if (
              filteredFlights.length > 0 &&
              singleLeg.option.flight_time <= maxDurationParam
            ) {
              return { ...singleLeg, options: filteredFlights };
            }
            return null;
          } else {
            if (singleLeg.option.flight_time <= maxDurationParam) {
              return { ...singleLeg };
            }
            return null;
          }
        })
        .filter(clusterObj => clusterObj !== null);

      return { ...clusterObj, combinations: newOptions };
    })
    .filter(clusterObj => clusterObj.combinations.length > 0);

  return [...newCluster.filter(clusterObj => clusterObj !== null)];
};
